// extracted by css-extract-rspack-plugin
export default {"menu":"context-menu-2__menu___y_hRq common__card___IF5rk common__shadow-card___vZlbB common__elevatedBox___sDouz","menuOption":"context-menu-2__menuOption___EyJxT"};